export enum LINKS {
  HOME = "/",

  FAQ = "/sporsmal-og-svar",
  HOW_IT_WORKS = "/how-it-works",

  CONTACT_US = "/kontakt",
  ABOUT = "/om-pafyll",
  WHAT_IS_PAFYLL = "/hva-er-pafyll",
  MISSION = "/mission",
  INSPIRATION = "/inspirasjon",

  PRODUCTS = "/products",
  SHOP = "/nettbutikk",
  SHOP_SOAP = "/nettbutikk/bestill-handsape-refill",
  SHOP_LAUNDRY = "/nettbutikk/bestill-vaskemiddel-refill",
  SHOP_CLEANING = "/nettbutikk/bestill-rengjoringsmidler-refill",

  ACCOUNT = "/account",
  ACCOUNT_EDIT = "/account/edit",
  ACCOUNT_ORDERS = "/account/orders",
  ACCOUNT_DELETE = "/account/delete",
  ACCOUNT_DELETE_SUCCESS = "/account/delete-success",

  ACCOUNT_RETRIEVAL = "/account/retrievals",
  ACCOUNT_DELIVERY = "/account/deliveries",

  LOGIN = "/login",
  LOGIN_SMS = "/login/sms",
  LOGIN_EMAIL = "/login/email",
  LOGIN_VERIFY = "/login/verify",

  REGISTER = "/register",
  REGISTER_USER = "/register/user",
  REGISTER_VERIFY = "/register/verify",
  REGISTER_ADDRESS = "/register/address",
  REGISTER_HOUSEHOLD = "/register/household",

  CHECKOUT = "/checkout",
  CHECKOUT_SUCCESS = "/checkout/success",
  CHECKOUT_FAILURE = "/checkout/failed",

  RETURN = "/return",
  RETURN_SUCCESS = "/return/success",

  PRIVACY = "/privacy-policy",
  TERMS = "/terms-of-sale",

  INSTAGRAM = "https://www.instagram.com/pafyll",
  FACEBOOK = "https://www.facebook.com/pafyllcom",
  LINKEDIN = "https://www.linkedin.com/company/pafyll",
}
